import { useEffect } from 'react'
import { useGetEventGroups } from 'Event/hooks/useGetEventGroups'
import useGetEventQuestionSets, { EventQuestionSet } from 'Event/hooks/useGetEventQuestionSets'
import { encodeOccurrenceFromEvent } from 'Event/helpers/encodeOccurrence'
import { mapToEventGroup } from 'Event/helpers/add-edit-helpers'
import {
  EventGroup,
  OpportunityOccurrencePersonGroup,
  OpportunityResponseWithRecurrenceInfo,
} from 'Event/interfaces/interfaceCreateEditEvent'

export const useEventDrilldownSupplementaryData = (event: OpportunityResponseWithRecurrenceInfo | null) => {
  const [getEventGroups, { loading: eventGroupsLoading, result: personGroups, called: groupsCalled }] =
    useGetEventGroups()
  const [getQuestionSets, { result: questionSets, loading: questionSetsLoading, called: questionSetsCalled }] =
    useGetEventQuestionSets()

  useEffect(() => {
    if (!event) {
      return
    }
    getEventGroups(event.id)
    if (event.schedulable) {
      getQuestionSets(encodeOccurrenceFromEvent(event))
    }
  }, [event, getEventGroups, getQuestionSets])

  const eventGroups: EventGroup[] = personGroups.map(mapToEventGroup)
  const loading =
    !groupsCalled || eventGroupsLoading || (event?.schedulable && (!questionSetsCalled || questionSetsLoading))

  return {
    personGroups: personGroups as OpportunityOccurrencePersonGroup[],
    eventGroups,
    questionSets: questionSets as EventQuestionSet[],
    loading,
  }
}
